import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Menu, X } from 'lucide-react'

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  return (
    <header className="bg-white shadow-sm border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link to="/" className="flex items-center">
              <img src="/images/icon.png" alt="Cirurgia Autorizada" className="w-8 h-8 mr-3" />
              <span className="text-xl font-bold text-gray-900">Cirurgia Autorizada</span>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <Link to="/" className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium transition-colors">
              Início
            </Link>
            <Link to="/sou-clinica-medica" className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium transition-colors">
              Para Clínicas
            </Link>
            <Link to="/sou-secretariao" className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium transition-colors">
              Para Secretariados
            </Link>
            <Link to="/sou-cirurgião" className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium transition-colors">
              Para Cirurgiões
            </Link>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:flex items-center space-x-4">
            <Button 
            variant="outline" 
            className="text-blue-600 border-blue-600 hover:bg-blue-50"
            onClick={() => window.open('https://app.cirurgiaautorizada.com.br', '_blank')}
            >
              Acessar Plataforma
            </Button>
            <Button 
              className="bg-orange-500 hover:bg-orange-600 text-white"
              onClick={() => window.open('https://app.cirurgiaautorizada.com.br/solicitacao', '_blank')}
            >
              Entregue sua Guia
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <Button variant="ghost" size="sm" onClick={toggleMenu}>
              {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </Button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white border-t border-gray-200">
              <Link
                to="/"
                className="text-gray-700 hover:text-blue-600 block px-3 py-2 text-base font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Início
              </Link>
              <Link
                to="/sou-clinica-medica"
                className="text-gray-700 hover:text-blue-600 block px-3 py-2 text-base font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Para Clínicas
              </Link>
              <Link
                to="/sou-secretariao"
                className="text-gray-700 hover:text-blue-600 block px-3 py-2 text-base font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Para Secretariados
              </Link>
              <Link
                to="/sou-cirurgião"
                className="text-gray-700 hover:text-blue-600 block px-3 py-2 text-base font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Para Cirurgiões
              </Link>
              <div className="pt-4 space-y-2">
                <Button 
                  variant="outline" 
                  className="w-full text-blue-600 border-blue-600 hover:bg-blue-50"
                  onClick={() => window.open('https://app.cirurgiaautorizada.com.br', '_blank')}
                >
                  Acessar Plataforma
                </Button>
                <Button 
                  className="w-full bg-orange-500 hover:bg-orange-600 text-white"
                  onClick={() => window.open('https://app.cirurgiaautorizada.com.br/solicitacao', '_blank')}
                >
                  Entregue sua Guia
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  )
}

export default Header

